import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  const footerSections = {
    support: {
      title: "Support",
      links: [
        { name: "Coronavirus (COVID-19) FAQs", href: "#" },
        { name: "Manage your trips", href: "#" },
        { name: "Contact Customer Service", href: "#" },
        { name: "Safety Resource Center", href: "#" }
      ]
    },
    discover: {
      title: "Discover",
      links: [
        { name: "Genius loyalty program", href: "#" },
        { name: "Seasonal and holiday deals", href: "#" },
        { name: "Travel articles", href: "#" },
        { name: "InnBotics for Business", href: "#" },
        { name: "Traveller Review Awards", href: "#" },
        { name: "Car rental", href: "#" },
        { name: "Flight finder", href: "#" },
        { name: "Restaurant reservations", href: "#" }
      ]
    },
    terms: {
      title: "Terms and settings",
      links: [
        { name: "Privacy & cookies", href: "#" },
        { name: "Terms and conditions", href: "#" },
        { name: "Partner dispute", href: "#" },
        { name: "Modern Slavery Statement", href: "#" },
        { name: "Human Rights Statement", href: "#" }
      ]
    },
    partners: {
      title: "Partners",
      links: [
        { name: "Extranet login", href: "#" },
        { name: "Partner help", href: "#" },
        { name: "List your property", href: "#" },
        { name: "Become an affiliate", href: "#" }
      ]
    },
    about: {
      title: "About",
      links: [
        { name: "About InnBotics", href: "#" },
        { name: "How we work", href: "#" },
        { name: "Sustainability", href: "#" },
        { name: "Press center", href: "#" },
        { name: "Careers", href: "#" },
        { name: "Investor relations", href: "#" }
      ]
    }
  };

  const socialLinks = [
    { name: "Facebook", icon: "FB", href: "#" },
    { name: "Twitter", icon: "TW", href: "#" },
    { name: "Instagram", icon: "IG", href: "#" },
    { name: "LinkedIn", icon: "LI", href: "#" }
  ];

  const countries = [
    "Pakistan", "United Arab Emirates", "Saudi Arabia", "India", 
    "United Kingdom", "United States", "Germany", "France"
  ];

  return (
    <footer className="footer">
      {/* Newsletter Section */}
      <div className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <div className="newsletter-info">
              <h3>Subscribe to see secret deals</h3>
              <p>Prices drop the second you sign up!</p>
            </div>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Your email address"
                className="newsletter-input"
              />
              <button className="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {Object.entries(footerSections).map(([key, section]) => (
              <div key={key} className="footer-section">
                <h4 className="footer-title">{section.title}</h4>
                <ul className="footer-links">
                  {section.links.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="footer-link">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Countries Section */}
          <div className="countries-section">
            <h4 className="footer-title">Countries and regions</h4>
            <div className="countries-grid">
              {countries.map((country, index) => (
                <a key={index} href="#" className="country-link">
                  {country}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-left">
              <div className="footer-logo">
                <span className="logo-icon">IB</span>
                <span className="logo-text">InnBotics</span>
              </div>
              <p className="footer-description">
                InnBotics is part of InnBotics Holdings Inc., the world leader in online travel and related services.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a key={index} href={social.href} className="social-link" title={social.name}>
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            <div className="footer-right">
              <div className="app-links">
                <p className="app-text">Get the InnBotics app</p>
                <div className="app-buttons">
                  <a href="#" className="app-btn">
                    <span className="app-icon">iOS</span>
                    App Store
                  </a>
                  <a href="#" className="app-btn">
                    <span className="app-icon">Android</span>
                    Google Play
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-copyright">
            <div className="copyright-text">
              <p>&copy; {new Date().getFullYear()} InnBotics. All rights reserved.</p>
              <p>
                InnBotics™ is a trademark of InnBotics Holdings Inc. 
                Company registered in Pakistan and other countries.
              </p>
            </div>
            <div className="footer-badges">
              <div className="badge">Secure Booking</div>
              <div className="badge">Privacy Protected</div>
              <div className="badge">Verified Reviews</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
